module.exports = __webpack_public_path__ + "img/pr-3.0553dff0.png";